import { toObject } from '@m1/geo-utils';
import OlMap from '@m1/ol-map';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { Draw } from 'ol/interaction';
import { toLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import React, { useMemo } from 'react';
import { RiCircleLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import actions from '@/actions';
import { CommandButton } from '@/components/ui/kit/Button';
import { FENCE_CIRCLE_RADIUS_MIN } from '@/config';
import { MISSION_STYLES } from '@/define/missionStyles';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';
import { NotifierService as notifier } from '@/libs/Notifier';
import { convertProjectedRadiusToMeters } from '@/utils/FenceUtil';

const DrawCircle = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.editor.mode);
  const map = OlMap.getMap();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const pressed = useMemo(() => {
    return mode === 'fence/circle';
  }, [mode]);

  useUpdateEffect(() => {
    if (!pressed) return;

    const interaction = new Draw({
      source: new VectorSource({ wrapX: false }),
      type: 'Circle',
      style: (feature) => {
        const geometry = feature.getGeometry();
        if (geometry.getType() !== 'Circle') return;

        return [
          MISSION_STYLES.FENCE.CIRCLE.OUTLINE,
          MISSION_STYLES.FENCE.CIRCLE.DIAMETER_LINE(geometry),
          MISSION_STYLES.FENCE.CIRCLE.DIAMETER_LABEL(geometry),
        ];
      },
    });
    interaction.on('drawend', drawCircle);
    map.addInteraction(interaction);

    return () => {
      map.removeInteraction(interaction);
    };
  }, [pressed]);

  const drawCircle = (e) => {
    const circle = e.feature.getGeometry();
    const center = toObject(toLonLat(circle.getCenter()));
    const radius = convertProjectedRadiusToMeters(circle);

    // 반지름 10m 미만 시
    if (radius < FENCE_CIRCLE_RADIUS_MIN) {
      notifier.error(`The fence radius cannot be smaller than ${FENCE_CIRCLE_RADIUS_MIN}m. Please redraw.`);
      return;
    }

    dispatch(actions.mission.mavlink.addFence('Circle', { center, radius }));
    dispatch(actions.editor.changeMode(null));
  };

  const toggle = () => {
    if (pressed) {
      dispatch(actions.editor.changeMode(null));
    } else {
      dispatch(actions.editor.changeMode('fence/circle'));
    }
  };

  return <CommandButton Icon={RiCircleLine} text="Circle" pressed={pressed} onClick={handleWithMoveCheck(toggle)} />;
};

export default DrawCircle;
